// Copy for /try, the destination for 1:1 outbound. Unlike the public site, this
// page is noindexed and reached only by people we deliberately mailed, so each
// variant is allowed to speak to one ICP in their own language. The DEFAULT
// variant stays broad: it is what anyone arriving without a tagged link sees,
// and Intakall is built for more than engineering.

export type Persona = "em" | "product" | "founder" | "ic";

export interface TryCopy {
  headline: string;
  subhead: string;
}

export const DEFAULT_COPY: TryCopy = {
  headline: "Your team's context, live in the call.",
  subhead:
    "Intakall surfaces the right ticket, decision, or doc while you are still talking, then writes up the notes and action items.",
};

export const PERSONA_COPY: Record<Persona, TryCopy> = {
  em: {
    headline: "Stop re-explaining the same context every standup.",
    subhead:
      "Intakall pulls the right PR, issue, or past decision into the call as you speak, so nobody has to stop and go find it.",
  },
  product: {
    headline: "Walk into every meeting with the roadmap already in the room.",
    subhead:
      "Intakall surfaces the ticket, spec, or decision behind whatever is being discussed, then writes the notes and action items so nothing gets lost.",
  },
  founder: {
    headline: "You should not be the only one who remembers why.",
    subhead:
      "Intakall brings the decision you already made back into the call as you speak, so you are not the one re-explaining it, and writes up the notes and action items.",
  },
  ic: {
    headline: "Stop digging through tickets and Slack channels.",
    subhead:
      "Intakall puts the right issue, doc, decision, or message on screen as it is mentioned, so you stay in the call instead of hunting through tabs.",
  },
};

const PERSONAS = new Set<string>(Object.keys(PERSONA_COPY));

/**
 * Resolve the `?p=` link tag to a copy variant. Anything unrecognised, empty, or
 * absent falls back to the broad default rather than erroring, because a mangled
 * link in a forwarded email should still land on a working page.
 */
export function getTryCopy(param: string | null | undefined): TryCopy {
  const key = param?.trim().toLowerCase();
  if (key && PERSONAS.has(key)) {
    return PERSONA_COPY[key as Persona];
  }
  return DEFAULT_COPY;
}
